module.exports = __webpack_public_path__ + "4d78f30edace6aeee08506cd6d6b57bb.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Tutors/images/img_tutor_joinus.svg
// module id = 1610
// module chunks = 8